import React from "react";
import * as S from "./styled";
import SearchIcon from "_c/icon/Search";
import SettingsIcon from "_c/icon/Settings";
import { useScrollDir, DIR } from "@/hooks/useScrollDir";
import { AnimatePresence } from "framer-motion";
import TextSearch from "../TextSearch/Mobile";
import DenyIcon from "_c/icon/Deny";
import PT from "prop-types";
import { MobileUiVars } from "../ui-vars";
import { useToggle } from "@/hooks/useToggle";
import { useHasTextSearch } from "../TextSearch/hooks";
import { useHasFilters } from "../Filters/hooks";
import { ORDERS_NS as NS } from "@/i18n/ns";

const MobileBottomBar = (props) => {
  const [searchOpen, toggleSearch] = useToggle(false);
  const dir = useScrollDir();
  const col = "var(--font-color-accent)";
  const barVisible = !dir || dir === DIR.UP || searchOpen;
  const hasTextSearch = useHasTextSearch(props.query);
  const hasFilters = useHasFilters(props.query);
  return (
    <>
      <AnimatePresence>
        {searchOpen && (
          <TextSearch
            key="text-search"
            query={props.query}
            updateQuery={props.updateQuery}
            t={props.t}
          />
        )}
      </AnimatePresence>
      <AnimatePresence>
        {barVisible && (
          <S.Wrap
            key="mobile-bar"
            transition={{ ease: "linear", duration: 0.2 }}
            initial={{ y: -MobileUiVars.bottomBarHeight }}
            animate={{ y: 0 }}
            exit={{ y: -MobileUiVars.bottomBarHeight }}
          >
            <S.Item onClick={toggleSearch}>
              <S.IconWrap>
                {searchOpen ? (
                  <DenyIcon color="var(--color-danger)" width="0.9em" />
                ) : (
                  <SearchIcon color={col} width="1em" />
                )}
              </S.IconWrap>
              <S.Title hasBadge={hasTextSearch}>
                {props.t(`${NS}:mobile_bar.search`)}
              </S.Title>
            </S.Item>
            <S.Item onClick={props.openFilters}>
              <S.IconWrap>
                <SettingsIcon color={col} width="0.9em" />
              </S.IconWrap>
              <S.Title hasBadge={hasFilters}>
                {props.t(`${NS}:mobile_bar.filters`)}
              </S.Title>
            </S.Item>
          </S.Wrap>
        )}
      </AnimatePresence>
    </>
  );
};
MobileBottomBar.propTypes = {
  query: PT.object.isRequired,

  openFilters: PT.func.isRequired,
  t: PT.func.isRequired,
};

export default MobileBottomBar;
